export default "/assets/images/CC-product-showcase-04.8dc135e4f59a19ff.jpg";